import dynamic from 'next/dynamic'
import { DemographicsIcon } from 'src/components/insights/icons/demographics'
import { InsightBuilderWidget } from 'src/types/insight-builder'
import preview from 'src/assets/images/widgets-previews/gender.png'

const DemographicsGender = dynamic(() => import('src/components/insights/demographics/cards/gender'), {
  ssr: false,
})

export const DemographicsGenderWidget: InsightBuilderWidget = {
  id: 'gender',
  name: 'Gender',
  type: 'Demographics',
  icon: DemographicsIcon,
  component: DemographicsGender,
  supportedResultTypes: ['alphamap-location'],
  preview,
}
